import { renderAdminThemeBlock } from '@next-adapter/templates/renderers/init/scaffolders/tailwind/admin-theme-block.js'

export function getAdminThemeVars(): string[] {
  return renderAdminThemeBlock()
    .split('\n')
    .filter((line) => line.trim().startsWith('--'))
}
